import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class CustomerContactsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "collections_email": "cobranzas@dundermifflin.com",
                "has_collections_email": true
            },
            errors: []
        }
    }

    collectionsEmail() {
        return this.content().collections_email;
    }

    hasCollectionsEmail() {
        return this.content().has_collections_email;
    }
}
